const BASE = '/api';

let _viewAs = null;
export function setApiViewAs(username) { _viewAs = username; }
export function clearApiViewAs() { _viewAs = null; }

async function request(path, options = {}) {
  const headers = { 'Content-Type': 'application/json', ...options.headers };
  if (_viewAs) headers['X-Ledger-ViewAs'] = _viewAs;

  let res;
  try {
    res = await fetch(`${BASE}${path}`, {
      credentials: 'include',
      headers,
      ...options,
    });
  } catch (err) {
    throw new Error('Server unavailable — try again in a moment');
  }

  if (res.status === 401 && path !== '/auth/login') {
    window.dispatchEvent(new CustomEvent('ledger-session-expired'));
    throw new Error('Session expired');
  }

  let data;
  try {
    data = await res.json();
  } catch {
    throw new Error(`Server error (${res.status})`);
  }
  if (!res.ok) throw new Error(data.error || 'Request failed');
  return data;
}

const api = {
  login: (email, password) => request('/auth/login', { method: 'POST', body: JSON.stringify({ email, password }) }),
  logout: () => request('/auth/logout', { method: 'POST' }),
  me: () => request('/auth/me'),
  changePassword: (currentPassword, newPassword) =>
    request('/auth/change-password', { method: 'POST', body: JSON.stringify({ currentPassword, newPassword }) }),

  getWipActive: () => request('/wip/active'),
  getWipCompleted: () => request('/wip/completed'),
  getProjectDetail: (id) => request(`/wip/project/${id}`),

  getDashboardSummary: () => request('/dashboard/summary'),
  getDashboardByPm: () => request('/dashboard/by-pm'),

  chat: (message, history) => request('/chat', { method: 'POST', body: JSON.stringify({ message, history }) }),

  getSnapshots: () => request('/snapshots'),
  captureSnapshot: (snapshotType, notes) => request('/snapshots/capture', { method: 'POST', body: JSON.stringify({ snapshotType, notes }) }),
  getSnapshot: (id) => request(`/snapshots/${id}`),
  compareSnapshots: (id, compareId) => request(`/snapshots/${id}/compare/${compareId}`),

  getSettings: () => request('/admin/settings'),
  updateSetting: (key, value) => request(`/admin/settings/${key}`, { method: 'PUT', body: JSON.stringify({ value }) }),

  getUsers: () => request('/admin/users'),
  createUser: (data) => request('/admin/users', { method: 'POST', body: JSON.stringify(data) }),
  updateUser: (id, data) => request(`/admin/users/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  resetUserPassword: (id, password) => request(`/admin/users/${id}/reset-password`, { method: 'POST', body: JSON.stringify({ password }) }),
};

export default api;
